import React from 'react';
import { Button, Popconfirm, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

const FeeActions = ({ onEdit, onDelete }) => (
  <Space>
    <Button type="text" icon={<EditOutlined />} onClick={onEdit} />
    <Popconfirm title="Tem certeza que deseja remover esta taxa?" onConfirm={onDelete}>
      <Button type="text" danger icon={<DeleteOutlined />} />
    </Popconfirm>
  </Space>
);

export default FeeActions;
